var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Digital-Settlements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-page---Go-to-Digital-settlements-witness",
    transform: "translate(-146, -1043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(146, 1043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    fill: "#165694",
    stroke: "#165694"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0.5 C12.6233526,0.5 14.9983526,1.56332372 16.7175144,3.28248558 C18.4366763,5.00164744 19.5,7.37664744 19.5,10 C19.5,11.7431749 19.0306538,13.376756 18.2111245,14.781048 C17.3622157,16.2356829 16.1378951,17.4444074 14.6709874,18.2743716 C13.2916892,19.0547671 11.6978264,19.5 10,19.5 C7.37664744,19.5 5.00164744,18.4366763 3.28248558,16.7175144 C1.56332372,14.9983526 0.5,12.6233526 0.5,10 C0.5,7.37664744 1.56332372,5.00164744 3.28248558,3.28248558 C5.00164744,1.56332372 7.37664744,0.5 10,0.5 Z",
    id: "Oval"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pen-line-solid",
    transform: "translate(4, 4)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2306125,0.439925701 L11.119886,1.36435624 C11.6841459,1.95092384 11.6841459,2.90116336 11.119886,3.48773096 L10.0274789,4.62332584 L7.09332747,1.57552058 L8.18573462,0.439925701 C8.74999451,-0.1466419 9.66409553,-0.1466419 10.2283554,0.439925701 L10.2306125,0.439925701 Z M1.32207732,7.57728028 L6.58323653,2.10577769 L9.51738796,5.15592922 L4.25397171,10.6250855 C4.01923959,10.8690977 3.72808149,11.0474142 3.40983891,11.1459576 L0.694620323,11.9765373 C0.505029,12.0351941 0.299638401,11.9812298 0.159701948,11.8334148 C0.0197654952,11.6855998 -0.0344034542,11.4767817 0.0220225347,11.2773487 L0.821014539,8.45478541 C0.9158102,8.12396129 1.08734521,7.8212924 1.32207732,7.57728028 Z M5.59691025,10.8737902 L12.4583105,10.8737902 C12.7584968,10.8737902 13,11.1248411 13,11.4368951 C13,11.7489491 12.7584968,12 12.4583105,12 L5.59691025,12 C5.29672398,12 5.05522075,11.7489491 5.05522075,11.4368951 C5.05522075,11.1248411 5.29672398,10.8737902 5.59691025,10.8737902 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePencil);
export default __webpack_public_path__ + "static/media/blue_pencil.7dcd69467637f00fb3ff08d9ebf36880.svg";
export { ForwardRef as ReactComponent };